type EscapeEvent = Pick<KeyboardEvent, 'defaultPrevented' | 'key'>

/**
 * Decide si el listener global del panel puede consumir la tecla.
 *
 * Radix también escucha en `document`: su `preventDefault()` llega después que el listener del
 * SidePanel. Por eso la capa modal se anuncia en el store ANTES del Escape y esta decisión usa las
 * dos defensas: la marca del evento para handlers React y la bandera para capas Radix.
 */
export function shouldCloseSidePanelFromKeydown(
  event: EscapeEvent,
  isEscapeCloseSuppressed: boolean
): boolean {
  return event.key === 'Escape' && !event.defaultPrevented && isEscapeCloseSuppressed === false
}
